import React from 'react';
import { PlayerName, number, ratio } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { Stats, useCachedOktaQuery } from '../../../data';

const Header = ({ pitcher, levelId, isLhb, splits, batter }) => {
    const { t: translate } = useTranslation();

    const handednessSplit = splits?.find(({ split }) => split === (isLhb ? 2 : 1));

    const { data: levelAverage, isLoading: isLoadingLevelAverage } = useCachedOktaQuery(
        ['currentLevelAverage', levelId],
        (t) => Stats.currentLevelAvgs(t, levelId),
    );

    let batterDisplay = '';
    if (batter) {
        batterDisplay = <PlayerName player={batter} bats={batter.Bats} />;
    } else {
        const lhh = translate('baseball.lhh');
        const rhh = translate('baseball.rhh');
        const batsL = 2;
        const batsR = 1;
        batterDisplay = isLhb ? <PlayerName name={lhh} bats={batsL} /> : <PlayerName name={rhh} bats={batsR} />;
    }

    return (
        <div>
            <h2 className="mb-0">
                <PlayerName player={pitcher} throws={pitcher.Throws} />&nbsp;
                {translate('baseball.abbr-versus')}&nbsp;
                {batterDisplay}
            </h2>
            {handednessSplit && !isLoadingLevelAverage && (
                <div className="header-wrapper text-uppercase">
                    <div>
                        {translate('sections.reports.pitcher.abbr-strikeout-pct')}: {number(100 * ratio(handednessSplit.so, handednessSplit.pa), 0)}%
                        {levelAverage?.length
                            ? ` (${levelAverage[0].Level.Abbr} ${translate('common.abbr-average')} 
                                ${levelAverage?.length ? number(100 * ratio(levelAverage[0].So, levelAverage[0].Pa), 0) : ''}%)`
                            : ''}
                    </div>
                    <span className="mx-2 header-divider">|</span>
                    <div>
                        {translate('baseball.abbr-walk-ubb-perc')}: {number(100 * ratio(handednessSplit.ubb, handednessSplit.pa), 0)}%
                        {levelAverage?.length
                            ? ` (${levelAverage[0].Level.Abbr} ${translate('common.abbr-average')} 
                                ${levelAverage?.length ? number(100 * ratio(levelAverage[0].Ubb, levelAverage[0].Pa), 0) : ''}%)`
                            : ''}
                    </div>
                    <span className="mx-2 header-divider">|</span>
                    <div>
                        {number(ratio(handednessSplit.gb, handednessSplit.fb + handednessSplit.pop), 1)}&nbsp;
                        {translate('baseball.abbr-g-f')}&nbsp;
                        {levelAverage?.length
                            ? `(${levelAverage[0].Level.Abbr} ${translate('common.abbr-average')} 
                            ${levelAverage?.length ? number(ratio(levelAverage[0].Gb, levelAverage[0].Fb + levelAverage[0].Pop), 1) : ''})`
                            : ''}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Header;
